import React from "react";

interface TextfieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
}

function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="box-border content-stretch flex flex-row gap-2 h-6 items-center justify-center p-0 relative shrink-0 w-full">
      <div className="basis-0 font-['Geist:Regular',_sans-serif] font-normal grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[14px] text-left">
        <p className="block leading-[18px]">{children}</p>
      </div>
    </div>
  );
}

function TextInput({
  value,
  onChange,
  placeholder,
  type = "text",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
}) {
  return (
    <div className="bg-[#faf9fb] h-12 relative rounded-2xl shrink-0 w-full">
      <div className="absolute border border-[#eae7ec] border-solid inset-0 pointer-events-none rounded-2xl" />
      <div className="flex flex-row items-center justify-center relative size-full">
        <div className="box-border content-stretch flex flex-row gap-2 h-12 items-center justify-center px-4 py-2 relative w-full">
          <input
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="inset-0 w-full h-full bg-transparent border-none outline-none text-[14px] font-['Geist:Regular',_sans-serif] text-[#211f26] cursor-text"
          />
        </div>
      </div>
    </div>
  );
}

export default function Textfield({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
}: TextfieldProps) {
  return (
    <div
      className="basis-0  box-border content-stretch flex flex-col gap-1 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0"
      data-name="Textfield"
    >
      {label && <FieldLabel>{label}</FieldLabel>}
      <TextInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
      />
    </div>
  );
}
